import { type } from '@ngrx/signals';
import { event, EventCreator } from '@ngrx/signals/events';

export const authSuccessWithToken: EventCreator<string, { isB2BRegistration: boolean }> = event(
  '[Auth Store] Auth Success With Token',
  type<{ isB2BRegistration: boolean }>()
);
